import React, { useState, useEffect } from "react";
import { Client, Hub } from "../../common/models";
import orgDataService from "services/orgDataService";
import {
  Grid,
  TextField,
} from "@mui/material";
import MDButton from "components/MDButton";
import MultiSelect from "common/components/MultiSelect";

const TripOperationsRiskFilters = ({ search, setSearch }) => {
  const [hubs, setHubs] = useState<Hub[]>([]);
  const [clients, setClients] = useState<Client[]>([]);

  useEffect(() => {
    orgDataService.getAllHubs().then((data) => setHubs(data));
    orgDataService.getAllClients().then((data) => setClients(data));
  }, []);

  const handleKeyDown = (e, identifierType) => {
    if (e.key === "Enter") {
      // Do code here
      e.preventDefault();
      search(e.target.value, identifierType);
    }
  };
  const clearFilters = () => {
    setSearch({ ...search, clientIds: [], hubIds:[], note: '' });
  };

  return (
    <>
      <Grid container>
        <MultiSelect
          label={"Hub"}
          values={hubs}
          selectedValues={search.hubIds}
          setSelectedValues={(values) => setSearch({ ...search, hubIds: values })}
        />
        <MultiSelect
          label={"Client"}
          values={clients}
          selectedValues={search.clientIds}
          setSelectedValues={(values) => setSearch({ ...search, clientIds: values })}
        />
        <TextField
          sx={{ mt: 2, ml: 1 }}
          name="operationsRiskNote"
          label="Ops Risk Note"
          value={search.note || ""}
          onChange={(e) => setSearch({ ...search, note: e.target.value })}
          onKeyDown={(e) => handleKeyDown(e, "note")}
        />

        <MDButton sx={{ mt: 2, ml: 1 }} onClick={clearFilters}>
          Clear
        </MDButton>
      </Grid>
    </>
  );
};
export default TripOperationsRiskFilters;
